import { createTheme } from '@mui/material'

export const appTheme = createTheme({
  palette: {
    primary: {
      main: '#ff7900',
      light: '#ff9838',
      dark: '#c95700',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#101820',
      light: '#1d2a35',
      dark: '#071017',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f6f7f8',
      paper: '#ffffff',
    },
    text: {
      primary: '#15191d',
      secondary: '#68727d',
    },
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: '"Bariol", "Segoe UI", Arial, sans-serif',
    button: {
      textTransform: 'none',
      fontWeight: 700,
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          border: '1px solid #e8eaed',
          boxShadow: '0 8px 22px rgba(17, 24, 39, 0.05)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
        },
      },
    },
  },
})
